export default __webpack_public_path__ + "c8f3e7b66814366bd09d968a3a50d3ce.webp";